document.addEventListener("DOMContentLoaded", (event) => {
  function update_checkout_button(update_cart_content) {
    var all_cart_items = update_cart_content.querySelectorAll(
      ".cart-items-selector"
    );
    var product_url = window.location.href.split("/products/")[1].split("?")[0];
    console.log(product_url);
    var item_count = 0;
    all_cart_items.forEach(function (item) {
      var item_href = item.querySelector("a.text-uppercase").href;
      var item_quantity = item.querySelector('[name="quantity"]').value;
      console.log(item_href);
      if (item_href.indexOf(product_url) > -1) {
        item_count += parseInt(item_quantity);
      }
    });
  }
  function load_ajax_cart(closest_div) {
    fetch("/cart?view=ajax", {
      method: "GET",
      headers: {
        "Content-Type": "application/Html",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.text();
      })
      .then((cartData) => {
        var update_cart_content = document.querySelector(".cart-item__wrapper");
        update_cart_content.innerHTML = cartData;
        // Update checkout button url
        update_checkout_button(update_cart_content);
        // Use DOM methods to extract paragraph text
        var header_cart_quantitys = document.querySelectorAll(
          "[data-cart-item-count]"
        );
        var cart_item_count = update_cart_content.querySelector(
          ".cart-item__extra_info"
        ).dataset.item_count;
        var cart_total_price = update_cart_content.querySelector(
          ".cart-item__extra_info"
        ).dataset.total_price;
        document.querySelector(".cart_item-count").innerHTML = cart_item_count;
        document.querySelector(".cart_item-total-price").innerHTML =
          cart_total_price;
        header_cart_quantitys.forEach(function (header_cart_quantity) {
          header_cart_quantity.innerHTML = cart_item_count.split(" ")[0];
          // console.log();
          header_cart_quantity.dataset.cartItemCount =
            cart_item_count.split(" ")[0];
        });
        closest_div.querySelector(".spinner-overlay").classList.add("d-none");
        document.querySelector(".header_click-event").click();
        document
          .querySelector(".cart_checkout-button")
          .classList.remove("d-none");
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  }
  function ajaxAddToCart(closest_div, formData) {
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        console.log(response);
        if (response.status == 422) {
          var inventory_count = response.description.split(" ")[1];
          var product_name = response.description
              .split("-")[0]
              .replace("0", ""),
            inventory_message;
          console.log(inventory_count, product_name);
          if (inventory_count == "0") {
            inventory_message = `${product_name} is sold out.`;
          } else {
            inventory_message = response.description;
          }
          //   closest_div.querySelector(".spinner-overlay").classList.add("d-none");
          closest_div.querySelector(".quantity-msg-alert").textContent =
            inventory_message;
          closest_div.querySelector(".quantity-msg-alert").style.display =
            "block";
          return false;
        } else {
          closest_div.querySelector(".quantity-msg-alert").style.display =
            "none";
        }
        load_ajax_cart(closest_div);
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  }

  function addProductToCart(element) {
    var closest_div = element.closest(".ads-product-variant__container");
    var variant_id = element
      .closest(".product-form")
      .querySelector('[name="id"]').value;
    var variant_qty = document.querySelector(".product-form-action__buttons input").value;
    console.log(variant_qty, variant_id);
    var variant_obj = {};
    variant_obj.id = variant_id;
    variant_obj.quantity = parseInt(variant_qty);
    var formData = { items: [] };
    formData.items.push(variant_obj);
    console.log(formData);
    ajaxAddToCart(closest_div, formData);
    // return false;
  }

  var button_add_to_cart = document.querySelectorAll(
    ".add-to-cart-button-wrapper button"
  );
  var button_add_to_cart2 = document.querySelector(
    ".add-to-cart-cta button"
  );
  button_add_to_cart.forEach(function (element) {
    element.addEventListener("click", function () {
      addProductToCart(element);
    });
  });
  button_add_to_cart2.addEventListener("click", function () {
    document.querySelector(".add-to-cart-button-wrapper button").click();
  });

  /*********** Swatch selection method *************/
  var variant_option = document.querySelectorAll(
    ".variant-blocks .variant-block"
  );
  function activeAddToCartButton(element) {
    var closest_div = element.closest(".ads-product-variant__container");
    closest_div
      .querySelector(".add-to-cart-button-wrapper")
      .classList.add("active");
    closest_div.querySelector(".proudct-add-to-cart-button span").textContent =
      "Add to cart";
  }
  function showColorVariantBox(element) {
    var variant_index = element.dataset.variant_index;
    // console.log("variant_index: " + variant_index);
    var closest_div = element.closest(".ads-product-variant__container");
    closest_div
      .querySelector(".color-line-item-properties")
      .classList.add("active");
    var color_block = closest_div.querySelectorAll(
      ".color-line-item-property-block"
    );
    color_block.forEach(function (div) {
      div.classList.remove("active");
      var color_block_index = div.dataset.color_index;
      // console.log(variant_index, color_block_index);
      if (color_block_index <= variant_index) {
        div.classList.add("active");
      }
    });
  }
  function variantClickEvent(element) {
    activeAddToCartButton(element);
    showColorVariantBox(element);
  }
  variant_option.forEach(function (element) {
    element.addEventListener("click", function (event) {
      variant_option.forEach(function (div) {
        div.classList.remove("active");
      });
      element.classList.add("active");
      variantClickEvent(element);
    });
  });
  function update_formData(inputValue, variant_id) {
    var color_swatch_array = [];
    if (color_swatch_array.indexOf(inputValue) > -1) {
    }
  }
});
